var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function($event) {
                  return _vm.nouveauPlanDeMenu()
                }
              }
            },
            [_c("i", { staticClass: "fas fa-plus" }), _vm._v(" Plan ")]
          )
        ]),
        _c(
          "b-modal",
          {
            ref: "modal-nouveauPlanDeMenu",
            attrs: { size: "xl", "hide-header": "", "hide-footer": "" }
          },
          [_c("MenusPlansEdition", { on: { "close-modal": _vm.closeModal } })],
          1
        ),
        _vm._l(_vm.menuPlans, function(item, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-12" },
            [
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "modalPlanDeMenu" + item.id,
                          expression: "'modalPlanDeMenu' + item.id"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.nom))]
                  )
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalPlanDeMenu" + item.id,
                  refInFor: true,
                  attrs: {
                    id: "modalPlanDeMenu" + item.id,
                    size: "xl",
                    "hide-header": "",
                    "hide-footer": ""
                  }
                },
                [
                  _c("PlanEdition", {
                    attrs: { planId: item.id },
                    on: {
                      "close-modal": function($event) {
                        return _vm.closeModal(item.id)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }